// @flow
import React from 'react';
import Loadable from 'react-loadable';

import createPrq from '../assets/images/create_prq.svg';
import createCn from '../assets/images/create_cn.svg';
import createPickupClient from '../assets/images/create_pickup_client.svg';
import checkPincodeClient from '../assets/images/check_pincode_client.svg';
import cnTrack from '../assets/images/cn_track.svg';
import pincodeService from '../assets/images/pincode_service.svg';
// import performanceIcon from "../assets/images/performance_icon.svg";
import faqIcon from '../assets/images/faq.svg';

import Loader from '../components/commons/loader/loader';

import NotFoundPage from '../components/commons/404/notFound';
import OaManager from '../components/containers/oaManager/oaManager';
import RetailCollections from '../components/containers/retailCollections/retailCollections';
import rpCollections from '../components/containers/rpCollections/rpCollections';
import collectionsHandover from '../components/containers/collectionsHandover/collectionsHandover';
import RetailCashbook from '../components/containers/retailCashbook/retailCashbook';
import DepositSlipDashboard from '../components/containers/depositSlip/dashboard/depositSlipDashboard';
import ClientCommunication from '../components/containers/clientCommunication/clientCommunication';
import checkPincode from '../components/containers/checkPincode/checkPincode';
import CETaskboard from '../components/containers/ceTaskboard/ceTaskboard';
import AddressFloorTagging from '../components/containers/addressFloorTagging/addressFloorTagging';

import {
  checkForBulkCnCreateAccess,
  checkForEretlClient,
  checkForNonEretlClient,
  rivigoUser
} from '../services/helpers';
import ManageVehicles from '../components/containers/manageVehicles/manageVehicles';
import faq from '../components/containers/faq/faq';
import damageCnUnblockAndRtoDashboard from '../components/containers/damageCnUnblockAndRto/dashboard/damageCnUnblockAndRtoDashboard';

function PreComponentLoading(props: Object) {
  return <Loader message={props.loadingMsg} />;
}

const CheckPincode = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "checkpincode" */) =>
    import('../components/containers/checkPincode/checkPincode'),
  loading: PreComponentLoading
});

const PickupDashboard = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "pickupdashboard" */) =>
    import('../components/containers/pickup/dashboard/pickupDashboard'),
  loading: PreComponentLoading
});

const PickupIncompleteCns = Loadable({
  loader: () =>
    import(
      '../components/containers/incompleteCn/dashboard/incompleteCnDashboard'
    ),
  loading: PreComponentLoading
});

const TrackingDashboard = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "trackingDashboard" */) =>
    import('../components/containers/bulkCn/dashboard/trackingDashboard'),
  loading: PreComponentLoading
});

const BulkCnFileConverter = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "bulkCnFileConverter" */) =>
    import('../components/containers/bulkCnFileConverter/bulkCnFileConverter'),
  loading: PreComponentLoading
});

const PrintBarcode = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "trackingDashboard" */) =>
    import('../components/containers/printBarcode/printBarcode'),
  loading: PreComponentLoading
});

const ServicePerformanceDashboard = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "ServicePerformanceDashboard" */) =>
    import('../components/containers/servicePerformance/servicePerformance'),
  loading: PreComponentLoading
});

const CostApprovalDashboard = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "costApprovalDashboard" */) =>
    import('../components/containers/deliverApprovals/deliveryApproval'),
  loading: PreComponentLoading
});

const PrsDrsCostApprosval = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "PrsDrsCostApprosval" */) =>
    import('../components/containers/prsDrsCostApproval/prsDrsCostApproval'),
  loading: PreComponentLoading
});
const blockCNDashboard = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "trackingDashboard" */) =>
    import('../components/containers/blockCN/dashboard/blockCNDashboard'),
  loading: PreComponentLoading
});

const CreatePrq = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "createprq" */) =>
    import('../components/containers/pickup/createPrq/createPrq'),
  loading: PreComponentLoading
});

const CreatePrqV3 = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "trackingDashboard" */) =>
    import('../components/containers/pickup/createPrqV3/createPrqV3'),
  loading: PreComponentLoading
});

const CreateBulkCn = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "createbulkcn" */) =>
    import('../components/containers/createBulkCn/createBulkCn'),
  loading: PreComponentLoading
});

const ShopFloor = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "manageLane" */) =>
    import('../components/containers/shopFloorManagement/shopfloor/shopfloor'),
  loading: Loader
});
const NetworkPlanning = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "networkPlanning" */) =>
    import('../components/containers/networkPlanning/networkPlanning'),
  loading: PreComponentLoading
});

const BpPassbookDashboard = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "bpPassbookDashboard" */) =>
    import('../components/containers/bpPassbook/dashboard/bpPassbookDashboard'),
  loading: PreComponentLoading
});

const CrmCalling = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "crmCalling" */) =>
    import('../components/containers/crmCalling/crmCalling'),
  loading: PreComponentLoading
});

const CmsPage = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "contentManagement" */) =>
    import('../components/containers/cms/cms'),
  loading: PreComponentLoading
});

const LoginOtp = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "loginOTP" */) =>
    import('../components/containers/loginOTP/loginOTP'),
  loading: PreComponentLoading
});

const MapView = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/mapView/mapView'),
  loading: PreComponentLoading
});

const AuditLogs = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/audit/audit'),
  loading: PreComponentLoading
});

const EPod = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/epod/epod'),
  loading: PreComponentLoading
});

// const VasCharges = Loadable({
//   // eslint-disable-next-line
//   loader: (/* webpackChunkName: "mapView" */) =>
//     import('../components/containers/vasCharges/vasCharges'),
//   loading: PreComponentLoading
// });

const VasExpenseDashboard = Loadable({
  loader: () =>
    import('../components/containers/vasCharges/vasExpenseDashboard'),
  loading: PreComponentLoading
});

const BulkCnUsingExcel = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/bulkCnUsingExcel/bulkCnUsingExcel'),
  loading: PreComponentLoading
});

const ConsolidatedEwCreator = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "mapView" */) =>
    import(
      '../components/containers/consolidatedEwCreator/consolidatedEwCreator'
    ),
  loading: PreComponentLoading
});

const DocumentChecker = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/documentChecker/DocumentChecker'),
  loading: PreComponentLoading
});

const BulkPincodeCheck = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/bulkPincodeCheck/bulkPincodeCheck'),
  loading: PreComponentLoading
});

const PickupTracking = Loadable({
  // eslint-disable-next-line
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/pickup/pickupTracking/pickupTracking'),
  loading: PreComponentLoading
});

const Faq = Loadable({
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/faq/faq'),
  loading: PreComponentLoading
});

const AirFlow = Loadable({
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/airflow/airflow'),
  loading: PreComponentLoading
});
const RpFreightCalculator = Loadable({
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/rpFreightCalculator/rpFreightCalculator'),
  loading: PreComponentLoading
});

const ChargeReconciliation = Loadable({
  loader: (/* webpackChunkName: "mapView" */) =>
    import('../components/containers/chargeReconciliation'),
  loading: PreComponentLoading
});

const ClaimsDashboard = Loadable({
  loader: (/* webpackChunkName: "claimsDashboard" */) =>
    import('../components/containers/claims/dashboard/claimsDashboard'),
  loading: PreComponentLoading
});

const ClaimDetailView = Loadable({
  loader: (/* webpackChunkName: "claimDetailView" */) =>
    import('../components/containers/claims/detail/claimDetailView'),
  loading: PreComponentLoading
});

const ClaimForm = Loadable({
  loader: (/* webpackChunkName: "claimForm" */) =>
    import('../components/containers/claims/form/claimForm'),
  loading: PreComponentLoading
});

const routesConfig: Array<any> = [
  {
    title: 'CREATE PICKUP',
    route: '/clientcreatepickup',
    menuBarColumnNo: 1,
    icnFile: createPrq,
    icnFileClient: createPickupClient,
    cellClassName: 'column1CellWrapper',
    component: CreatePrq,
    zoomuinewroute: true,
    icnClassName: 'createPickupIcn',
    icnClientClassName: 'createPickupClientIcn',
    isAuthorized: (userProfile: Object) => checkForNonEretlClient(userProfile)
  },
  {
    title: 'CREATE PICKUP',
    route: '/createprq',
    roles: ['ROLE_CREATE_PICKUP'],
    menuBarColumnNo: 1,
    icnFile: createPrq,
    cellClassName: 'column1CellWrapper',
    component: CreatePrq,
    zoomuinewroute: true,
    icnClassName: 'createPickupIcn'
  },
  {
    title: 'CREATE PICKUP E-RETAIL',
    route: '/publiccreatepickup',
    roles: ['ROLE_CREATE_PICKUP'],
    menuBarColumnNo: 1,
    icnFile: createPrq,
    icnFileClient: createPickupClient,
    cellClassName: 'column1CellWrapper',
    component: CreatePrqV3,
    zoomuinewroute: true,
    icnClassName: 'createPickupIcn',
    icnClientClassName: 'createPickupClientIcn',
    isAuthorized: (userProfile: Object) => checkForEretlClient(userProfile)
  },
  {
    title: 'CREATE PICKUP(NEW)',
    route: '/techsupportprq',
    roles: ['ROLE_VIEW_ZOOM_TECH_SUPPORT_PANEL'],
    menuBarColumnNo: 1,
    icnFile: createPrq,
    icnFileClient: createPickupClient,
    cellClassName: 'column1CellWrapper',
    component: CreatePrqV3,
    zoomuinewroute: true,
    icnClassName: 'createPickupIcn',
    icnClientClassName: 'createPickupClientIcn'
  },
  {
    title: 'CREATE CN',
    route: 'createcnote',
    roles: ['ROLE_CREATE_CNOTE'],
    previousRoute: true,
    menuBarColumnNo: 1,
    icnFile: createCn,
    cellClassName: 'column1CellWrapper',
    icnClassName: 'createCnIcn'
  },
  {
    title: 'Create CN (Logifreight)',
    route: '/createcnlogifreight',
    roles: ['ROLE_VIEW_CREATE_CN_LOGIFREIGHT'],
    zoomuinewroute: true,
    menuBarColumnNo: 1,
    icnFile: cnTrack,
    icnFileClient: cnTrack,
    cellClassName: 'column1CellWrapper',
    icnClassName: 'cnTrackingIcn',
    icnClientClassName: 'createPickupClientIcn',
    component: AirFlow,
    exact: true
  },
  {
    title: 'BULK CN TOOL',
    route: '/create-bulk-cn-using-excel',
    roles: ['ROLE_BULK_UPLOAD_USER'],
    menuBarColumnNo: 1,
    icnFile: createPrq,
    icnFileClient: createPickupClient,
    cellClassName: 'column1CellWrapper',
    component: BulkCnUsingExcel,
    zoomuinewroute: true,
    icnClassName: 'createPickupIcn',
    icnClientClassName: 'createPickupClientIcn'
  },
  {
    title: 'CN DASHBOARD',
    roles: ['ROLE_CLIENT_DASHBOARD'],
    route: 'mis',
    previousRoute: true,
    menuBarColumnNo: 1,
    icnFile: cnTrack,
    icnFileClient: cnTrack,
    cellClassName: 'column1CellWrapper',
    icnClassName: 'cnTrackingIcn',
    icnClientClassName: 'createPickupClientIcn'
  },
  {
    title: 'UPDATE PRQ',
    route: '/prq/:id',
    roles: ['ROLE_CREATE_PICKUP', 'ROLE_CLIENT_CREATE_PICKUP'],
    zoomuinewroute: true,
    component: CreatePrq
  },
  {
    title: 'CN TRACKING',
    route: '/bulktrackconsignment',
    roles: [
      'ROLE_TRACK_BARCODE',
      'ROLE_ZOOM_CLIENT_ADMIN',
      'ROLE_ZOOM_CLIENT_CONSIGNOR',
      'ROLE_ZOOM_CLIENT_CONSIGNEE'
    ],
    zoomuinewroute: true,
    menuBarColumnNo: 1,
    icnFile: cnTrack,
    icnFileClient: cnTrack,
    cellClassName: 'column1CellWrapper',
    icnClassName: 'cnTrackingIcn',
    icnClientClassName: 'createPickupClientIcn',
    component: TrackingDashboard,
    exact: true
  },
  {
    title: 'SERVICE PERFORMANCE DASHBOARD',
    route: '/serviceperformance',
    roles: ['ROLE_PERFORMANCE_DASHBOARD'],
    zoomuinewroute: true,
    menuBarColumnNo: 1,
    icnFile: cnTrack,
    icnFileClient: cnTrack,
    cellClassName: 'column1CellWrapper',
    icnClassName: 'cnTrackingIcn',
    icnClientClassName: 'createPickupClientIcn',
    component: ServicePerformanceDashboard,
    exact: true
  },
  {
    title: 'DIRECT DELIVERY APPROVAL DASHBOARD',
    route: '/directdeliveryApproval',
    roles: [
      'ROLE_DELIVER_CN_WITHOUT_DRS_FINAL_APPROVAL',
      'ROLE_DELIVER_CN_WITHOUT_DRS_FIRST_APPROVAL'
    ],
    zoomuinewroute: true,
    menuBarColumnNo: 1,
    icnFile: cnTrack,
    icnFileClient: cnTrack,
    cellClassName: 'column1CellWrapper',
    icnClassName: 'cnTrackingIcn',
    icnClientClassName: 'createPickupClientIcn',
    component: CostApprovalDashboard,
    exact: true
  },
  {
    title: 'PRS/DRS COST APPROVAL',
    route: '/prsdrscostapproval',
    roles: ['ROLE_VIEW_EXPENSE_APPROVAL'],
    zoomuinewroute: true,
    menuBarColumnNo: 1,
    icnFile: cnTrack,
    icnFileClient: cnTrack,
    cellClassName: 'column1CellWrapper',
    icnClassName: 'cnTrackingIcn',
    icnClientClassName: 'createPickupClientIcn',
    component: PrsDrsCostApprosval,
    exact: true
  },
  {
    route: '/bulktrackconsignment/:id?',
    roles: [
      'ROLE_ANONYMOUS_USER', // external user
      'ROLE_TRACK_BARCODE',
      'ROLE_EXTERNAL_TRACKING',
      'ROLE_CLIENT_CREATE_PICKUP', // client roles
      'ROLE_CLIENT_EDIT_PICKUP',
      'ROLE_CLIENT_PICKUP_DASHBOARD',
      'ROLE_EXTERNAL_TRACKING',
      'ROLE_ZOOM_CLIENT_ADMIN',
      'ROLE_CLIENT_DASHBOARD',
      'ROLE_TRACK_PICKUP',
      'ROLE_SPECIAL_USERS_HITTING_API',
      'ROLE_CLIENT_DELETE_PICKUP',
      'ROLE_ZOOM_CLIENT',
      'ROLE_VIEW_CLIENT_COMMUNICATION'
    ],
    zoomuinewroute: true,
    component: TrackingDashboard,
    exact: true,
    title: 'BULK CONSIGNMENT TRACKING'
  },
  {
    title: 'BULK CN FILE CONVERTER',
    route: '/bulkcnfileconverter',
    roles: ['ROLE_BULK_CN_FILE_CONVERTER'],
    zoomuinewroute: true,
    component: BulkCnFileConverter,
    menuBarColumnNo: 1,
    icnFile: cnTrack,
    icnFileClient: cnTrack,
    cellClassName: 'column1CellWrapper',
    icnClassName: 'cnTrackingIcn',
    icnClientClassName: 'createPickupClientIcn',
    exact: true
  },
  // {
  //   title: 'PICKUP TRACKING',
  //   route: 'pickuptracking',
  //   roles: ['ROLE_VIEW_TRACK_PICKUP'],
  //   previousRoute: true,
  //   menuBarColumnNo: 1,
  //   icnFile: cnTrack,
  //   cellClassName: 'column1CellWrapper',
  //   icnClassName: 'cnTrackingIcn'
  // },
  {
    title: 'PICKUP TRACKING',
    route: '/pickuptracking',
    component: PickupTracking,
    roles: [
      'ROLE_VIEW_TRACK_PICKUP',
      'ROLE_RELIANCE_CONSIGNOR_USER',
      'ROLE_RELIANCE_ADMIN_USER'
    ],
    zoomuinewroute: true,
    menuBarColumnNo: 1,
    icnFile: cnTrack,
    cellClassName: 'column1CellWrapper',
    icnClassName: 'cnTrackingIcn',
    exact: true
  },
  {
    title: 'PICKUP TRACKING PARAMS',
    route: '/pickuptracking/:id?',
    component: PickupTracking,
    zoomuinewroute: true,
    exact: true
  },
  {
    title: 'CHECK PINCODE',
    route: '/pincodeServiceability',
    cellClassName: 'column1CellWrapper',
    component: CheckPincode,
    zoomuinewroute: true,
    showToTech: true,
    menuBarColumnNo: 1,
    icnFile: pincodeService,
    icnFileClient: checkPincodeClient,
    icnClassName: 'pincodeServiceIcn',
    icnClientClassName: 'createPickupClientIcn'
  },
  {
    title: 'CHECK PINCODE',
    route: '/clientPincodeServiceability',
    cellClassName: 'column1CellWrapper',
    component: CheckPincode,
    zoomuinewroute: true,
    roles: [
      'ROLE_ZOOM_CLIENT_ADMIN',
      'ROLE_ZOOM_CLIENT_CONSIGNOR',
      'ROLE_ZOOM_CLIENT_CONSIGNEE'
    ],
    menuBarColumnNo: 1,
    icnFile: pincodeService,
    icnFileClient: checkPincodeClient,
    icnClassName: 'pincodeServiceIcn',
    icnClientClassName: 'createPickupClientIcn'
  },
  {
    title: 'RIVIGO CHECK PINCODE',
    route: '/rivigoClientPincodeServiceability',
    cellClassName: 'column1CellWrapper',
    component: CheckPincode,
    zoomuinewroute: true,
    roles: ['ROLE_ANONYMOUS_USER']
  },
  {
    title: 'BULK PINCODE CHECK',
    route: '/bulkPincodeCheck',
    cellClassName: 'column1CellWrapper',
    component: BulkPincodeCheck,
    zoomuinewroute: true,
    menuBarColumnNo: 1,
    icnFile: pincodeService,
    icnFileClient: checkPincodeClient,
    icnClassName: 'pincodeServiceIcn',
    icnClientClassName: 'createPickupClientIcn',
    isAuthorized: (userProfile: Object) => rivigoUser(userProfile)
  },
  {
    title: 'FAQ',
    route: '/faq',
    component: Faq,
    zoomuinewroute: true,
    menuBarColumnNo: 1,
    icnFile: faqIcon,
    cellClassName: 'column1CellWrapper',
    icnClassName: 'cnTrackingIcn',
    exact: true
  },
  {
    title: 'CLAIMS',
    route: '/claims',
    component: ClaimsDashboard,
    zoomuinewroute: true,
    roles: [
      'ROLE_ZOOM_CLIENT_ADMIN',
      'ROLE_ZOOM_CLIENT_CONSIGNOR',
      'ROLE_ZOOM_CLIENT_CONSIGNEE'
    ],
    menuBarColumnNo: 2,
    exact: true
  },
  {
    title: 'NEW CLAIM',
    route: '/claims/new',
    component: ClaimForm,
    zoomuinewroute: true,
    roles: [
      'ROLE_ZOOM_CLIENT_ADMIN',
      'ROLE_ZOOM_CLIENT_CONSIGNOR',
      'ROLE_ZOOM_CLIENT_CONSIGNEE'
    ],
    exact: true
  },
  {
    title: 'EDIT CLAIM',
    route: '/claims/:id/edit',
    component: ClaimForm,
    zoomuinewroute: true,
    roles: [
      'ROLE_ZOOM_CLIENT_ADMIN',
      'ROLE_ZOOM_CLIENT_CONSIGNOR',
      'ROLE_ZOOM_CLIENT_CONSIGNEE'
    ],
    exact: true
  },
  {
    title: 'CLAIM DETAIL',
    route: '/claims/:id',
    component: ClaimDetailView,
    zoomuinewroute: true,
    roles: [
      'ROLE_ZOOM_CLIENT_ADMIN',
      'ROLE_ZOOM_CLIENT_CONSIGNOR',
      'ROLE_ZOOM_CLIENT_CONSIGNEE'
    ],
    exact: true
  },
  // second column for tech
  {
    title: 'PICKUPS',
    menuBarColumnNo: 2,
    subRoutes: [
      {
        title: 'DASHBOARD',
        route: '/prqdashboard',
        zoomuinewroute: true,
        component: PickupDashboard,
        showToTech: true
      },
      {
        title: 'ARRIVAL PENDING',
        route: 'arrivalpending',
        previousRoute: true,
        roles: ['ROLE_VIEW_ARRIVAL_PENDING_PICKUP']
      },
      {
        title: 'INCOMPLETE CNS',
        route: '/incompletecnote',
        zoomuinewroute: true,
        component: PickupIncompleteCns,
        roles: ['ROLE_VIEW_INCOMPLETE_CNS_PICKUP']
      },
      {
        title: 'PICKUPS PENDING',
        route: 'createcnotepickup',
        previousRoute: true,
        roles: ['ROLE_CAPTAIN_WEB_APP']
      }
    ]
  },
  // second column for clients
  {
    title: 'REQUEST',
    menuBarColumnNo: 2,
    subRoutes: [
      {
        title: 'CREATE PICKUP',
        route: '/clientcreatepickup',
        zoomuinewroute: true,
        component: createPrq,
        isAuthorized: (userProfile: Object) =>
          checkForNonEretlClient(userProfile)
      },
      {
        title: 'CLAIMS',
        route: '/claims',
        zoomuinewroute: true,
        component: ClaimsDashboard,
        roles: [
          'ROLE_ZOOM_CLIENT_ADMIN',
          'ROLE_ZOOM_CLIENT_CONSIGNOR',
          'ROLE_ZOOM_CLIENT_CONSIGNEE'
        ]
      }
      // {
      //   title: 'BULK CN TOOL',
      //   route: '/create-bulk-cn-using-excel',
      //   zoomuinewroute: true,
      //   component: BulkCnUsingExcel,
      //   roles: ['ROLE_BULK_UPLOAD_USER'],
      //   menuBarColumnNo: 3
      // }
    ]
  },
  // third column for tech
  {
    title: 'TRIPS',
    route: 'trips',
    previousRoute: true,
    roles: ['ROLE_VIEW_TRIPS'],
    menuBarColumnNo: 3
  },
  {
    title: 'TRIPS',
    route: 'df_trips',
    previousRoute: true,
    roles: ['ROLE_VIEW_DF_TRIPS'],
    menuBarColumnNo: 3
  },
  {
    title: 'DELIVERIES',
    previousRoute: true,
    route: 'deliveries',
    roles: ['ROLE_SEND_FOR_DELIVERY'],
    menuBarColumnNo: 3
  },
  {
    title: 'LOAD VIEW',
    previousRoute: true,
    route: 'loadview',
    roles: ['ROLE_LOAD_VIEW'],
    menuBarColumnNo: 3
  },
  {
    title: 'BLOCK CN',
    route: '/blockcn',
    zoomuinewroute: true,
    roles: ['ROLE_BLOCK_CN'],
    component: blockCNDashboard,
    menuBarColumnNo: 3
  },
  {
    title: 'CLIENT CONFIRMATION',
    route: '/clientconfirm',
    zoomuinewroute: true,
    roles: ['ROLE_DEPS_ACTION_CONFIRMATION'],
    component: damageCnUnblockAndRtoDashboard,
    menuBarColumnNo: 3
  },
  {
    title: 'OFFLOADING',
    previousRoute: true,
    route: 'offloading',
    roles: ['ROLE_VIEW_ARRIVAL_PENDING_PICKUP'],
    menuBarColumnNo: 3
  },

  // third column for clients
  {
    title: 'TRACK',
    menuBarColumnNo: 3,
    subRoutes: [
      {
        title: 'PICKUP DASHBOARD',
        route: '/clientpickupdashboard',
        zoomuinewroute: true,
        hideForReliance: true,
        component: PickupDashboard,
        roles: [
          'ROLE_ZOOM_CLIENT_ADMIN',
          'ROLE_ZOOM_CLIENT_CONSIGNOR',
          'ROLE_ZOOM_CLIENT_CONSIGNEE'
        ]
      }
    ]
  },
  {
    title: 'PASSBOOK',
    route: 'bfpassbook',
    previousRoute: true,
    menuBarColumnNo: 3,
    roles: ['ROLE_ZOOM_BF_SA_ADMIN', 'ROLE_ZOOM_BF_TERMINAL']
  },
  {
    title: 'PAYMENT HISTORY',
    route: 'bfPaymentHistory',
    previousRoute: true,
    menuBarColumnNo: 3,
    roles: ['ROLE_ZOOM_BF_SA_ADMIN', 'ROLE_ZOOM_BF_TERMINAL']
  },
  {
    title: 'CHARGE RECONCILIATION',
    roles: [
      'ROLE_VIEW_CHARGE_RECONCILIATION_ADMIN',
      'ROLE_VIEW_CHARGE_RECONCILIATION'
    ],
    route: '/chargeReconciliation',
    component: ChargeReconciliation,
    zoomuinewroute: true,
    menuBarColumnNo: 3
  },

  {
    title: 'Freight Calculator',
    route: '/rpFreightCalculator',
    zoomuinewroute: true,
    menuBarColumnNo: 3,
    component: RpFreightCalculator,
    roles: [
      'ROLE_RETAIL_FREIGHT_CALCULATOR',
      'ROLE_ZOOM_BF_TERMINAL',
      'ROLE_ZOOM_BF_OA'
    ]
  },

  // 4th column for Clients
  {
    title: 'INFORMATION',
    menuBarColumnNo: 4,
    subRoutes: [
      {
        title: 'CHECK PINCODE',
        route: '/clientPincodeServiceability',
        zoomuinewroute: true,
        component: checkPincode,
        roles: [
          'ROLE_ZOOM_CLIENT_ADMIN',
          'ROLE_ZOOM_CLIENT_CONSIGNOR',
          'ROLE_ZOOM_CLIENT_CONSIGNEE'
        ]
      },
      {
        title: 'DEVELOPER',
        roles: [
          'ROLE_ZOOM_CLIENT_ADMIN',
          'ROLE_ZOOM_CLIENT_CONSIGNOR',
          'ROLE_ZOOM_CLIENT_CONSIGNEE'
        ],
        route: 'dev',
        routedeveloper: true
      }
    ]
  },
  {
    // fourth column
    title: 'DEPS',
    menuBarColumnNo: 4,
    roles: ['ROLE_REPORT_DEPS'],
    subRoutes: [
      {
        title: 'REPORT',
        route: 'reportdeps',
        previousRoute: true,
        roles: ['ROLE_REPORT_DEPS']
      },
      {
        title: 'INBOUND',
        route: 'inbounddeps',
        previousRoute: true,
        roles: ['ROLE_VIEW_INBOUND_DEPS']
      },
      {
        title: 'OUTBOUND',
        route: 'outbounddeps',
        previousRoute: true,
        roles: ['ROLE_VIEW_OUTBOUND_DEPS']
      }
    ]
  },
  // {
  //   title: "QC",
  //   menuBarColumnNo: 4,
  //   roles: ["ROLE_VIEW_CREATE_QC"],
  //   subRoutes: [
  //     {
  //       title: "CREATE QC TICKET",
  //       route: "/createqcticket",
  //       component: CreateQcTicket,
  //       roles: ["ROLE_VIEW_CREATE_QC"],
  //       zoomuinewroute: true
  //     }
  //   ]
  // },
  {
    title: 'SETTINGS',
    menuBarColumnNo: 5,
    subRoutes: [
      {
        title: 'MANAGE USERS',
        route: '/client-manage-alerts',
        zoomuinewroute: true,
        roles: ['ROLE_ZOOM_CLIENT_ADMIN'],
        component: ClientCommunication
      }
    ]
  },
  {
    title: 'BILLING & PAYMENTS',
    isExternalRoute: true,
    route: 'shipUrl',
    roles: [
      'ROLE_ZOOM_CLIENT_ADMIN',
      'ROLE_ZOOM_CLIENT_CONSIGNOR',
      'ROLE_ZOOM_CLIENT_CONSIGNEE'
    ],
    menuBarColumnNo: 6
  },
  {
    // fifth column
    title: 'OU MANAGEMENT',
    menuBarColumnNo: 5,
    subRoutes: [
      {
        title: 'FORWARDING NOTE',
        route: 'fn',
        previousRoute: true,
        roles: ['ROLE_VIEW_FORWARD_NOTE']
      },
      {
        title: 'OA Manager',
        route: '/oamanager',
        component: OaManager,
        roles: ['ROLE_VIEW_OA_MANAGER'],
        zoomuinewroute: true
      },
      {
        title: 'Collections',
        route: '/retail-collections',
        component: RetailCollections,
        roles: [
          'ROLE_VIEW_COLLECTIONS_SUMMARY',
          'ROLE_VIEW_COLLECTIONS_HANDOVER'
        ],
        zoomuinewroute: true
      },
      {
        title: 'RP Collections',
        route: '/rp-collections',
        component: rpCollections,
        routeProps: { expenseType: 'RP' },
        roles: [
          'ROLE_ZOOM_FINANCE_RP_COLLECTION',
          'ROLE_ZOOM_RP_COLLECTION_USER'
        ],
        zoomuinewroute: true
      },
      {
        title: 'BP Collections',
        route: '/bp-collections',
        component: rpCollections,
        routeProps: { expenseType: 'BP' },
        roles: [
          'ROLE_ZOOM_FINANCE_BP_COLLECTION',
          'ROLE_ZOOM_BP_COLLECTION_USER'
        ],
        zoomuinewroute: true
      },
      {
        title: 'Handover',
        route: '/collections-handover',
        component: collectionsHandover,
        roles: ['ROLE_VIEW_COLLECTIONS_HANDOVER'],
        zoomuinewroute: true
      },
      {
        title: 'Deposit Slip',
        route: '/deposit-slip',
        component: DepositSlipDashboard,
        roles: ['ROLE_VIEW_RETAIL_CASHBOOK'],
        zoomuinewroute: true
      },
      {
        title: 'Retail Cashbook',
        route: '/retail-cashbook',
        component: RetailCashbook,
        roles: ['ROLE_VIEW_RETAIL_CASHBOOK'],
        zoomuinewroute: true
      },
      {
        title: 'SHOP FLOOR',
        route: '/shopfloor',
        component: ShopFloor,
        roles: ['ROLE_EDIT_SHOP_FLOOR'],
        zoomuinewroute: true
      },
      {
        title: 'DOCUMENT CHECKER',
        route: '/documentChecker',
        cellClassName: 'column5CellWrapper',
        component: DocumentChecker,
        roles: ['ROLE_DOCUMENT_CHECKER'],
        zoomuinewroute: true
      },
      {
        title: 'Bulk Upload POD',
        route: 'bulkupload',
        roles: ['ROLE_BULK_UPLOAD_POD'],
        previousRoute: true,
        menuBarColumnNo: 1,
        icnFile: createCn,
        cellClassName: 'column1CellWrapper',
        icnClassName: 'createCnIcn'
      },
      {
        title: 'Bulk Download POD',
        route: 'bulkdownload',
        roles: ['ROLE_BULK_DOWNLOAD_POD'],
        previousRoute: true,
        menuBarColumnNo: 1,
        icnFile: createCn,
        cellClassName: 'column1CellWrapper',
        icnClassName: 'createCnIcn'
      }
    ]
  },
  {
    title: 'DASHBOARD',
    route: 'dashboard',
    previousRoute: true,
    roles: ['ROLE_VIEW_PERISCOPE_DASHBOARD'],
    subRoutes: [
      {
        title: 'Pickup Dashboard',
        route: 'bppickupdashboard',
        previousRoute: true,
        roles: ['ROLE_VIEW_PERISCOPE_DASHBOARD']
      },
      {
        title: 'Delivery Dashboard',
        route: 'bpdeliverydashboard',
        previousRoute: true,
        roles: ['ROLE_VIEW_PERISCOPE_DASHBOARD']
      },
      {
        title: 'Load View Dashboard',
        route: 'bploadviewdashboard',
        previousRoute: true,
        roles: ['ROLE_VIEW_PERISCOPE_DASHBOARD']
      }
    ],
    menuBarColumnNo: 5
  },
  {
    title: 'CE TASKBOARD',
    route: '/cetaskboard',
    zoomuinewroute: true,
    roles: ['ROLE_CE_TASKBOARD'],
    component: CETaskboard,
    menuBarColumnNo: 6
  },
  {
    title: 'Address Floor Tagging',
    route: '/addressFloorTagging',
    zoomuinewroute: true,
    roles: ['ROLE_CE_TASKBOARD'],
    component: AddressFloorTagging,
    menuBarColumnNo: 6
  },
  {
    title: 'CLM SUPPORT',
    route: 'cmcnote',
    previousRoute: true,
    roles: ['ROLE_VIEW_CLM_PANEL'],
    menuBarColumnNo: 6
  },
  {
    title: 'FINANCE SUPPORT',
    route: 'finsupport',
    previousRoute: true,
    roles: ['ROLE_VIEW_FINANCE_PANEL'],
    menuBarColumnNo: 6
  },
  {
    title: 'OPC PANEL',
    route: 'opcpanel',
    previousRoute: true,
    roles: ['ROLE_VIEW_OPC_PANEL'],
    menuBarColumnNo: 6
  },
  {
    title: 'TECH SUPPORT',
    route: 'techsupport',
    previousRoute: true,
    roles: ['ROLE_VIEW_ZOOM_TECH_SUPPORT_PANEL'],
    menuBarColumnNo: 6
  },
  {
    title: 'VAS CHARGES',
    route: '/vas-charges',
    component: VasExpenseDashboard,
    zoomuinewroute: true,
    roles: ['ROLE_VAS_ADD', 'ROLE_VAS_MASTER_USER', 'ROLE_CLAIM_SAM_KAM'],
    menuBarColumnNo: 6
  },
  {
    title: 'MAP VIEW',
    route: '/mapview',
    component: MapView,
    zoomuinewroute: true,
    roles: ['ROLE_ACCESS_CN_MAP_VIEW'],
    menuBarColumnNo: 6
  },
  {
    title: 'AUDIT LOGS',
    route: '/audit',
    zoomuinewroute: true,
    component: AuditLogs,
    roles: ['ROLE_ZOOM_AUDIT_LOG'],
    menuBarColumnNo: 6
  },
  {
    title: 'CN CONTINUUM',
    route: 'cnContinuum',
    roles: ['ROLE_VIEW_CONTINUUM'],
    previousReactRoute: true,
    menuBarColumnNo: 6
  },
  {
    title: 'MANAGE ALERTS',
    route: '/manage-alerts',
    zoomuinewroute: true,
    menuBarColumnNo: 6,
    showToTech: true,
    component: ClientCommunication
  },
  {
    title: 'MANAGE Vehicles',
    route: '/manage-vehicles',
    zoomuinewroute: true,
    menuBarColumnNo: 6,
    showToTech: true,
    roles: ['ROLE_ZOOM_PA'],
    component: ManageVehicles
  },
  {
    title: 'NETWORK PLANNER',
    route: '/networkplanner',
    component: NetworkPlanning,
    roles: ['ROLE_VIEW_NETWORK_PLANNER'],
    zoomuinewroute: true,
    menuBarColumnNo: 6
  },
  {
    title: 'PRINT BARCODE',
    route: '/printbarcode',
    roles: ['ROLE_PRINT_BARCODE_FROM_OPS'],
    zoomuinewroute: true,
    menuBarColumnNo: 6,
    component: PrintBarcode
  },
  {
    title: 'BP Passbook',
    route: '/bppassbook',
    component: BpPassbookDashboard,
    roles: ['ROLE_ZOOM_BP'],
    zoomuinewroute: true,
    menuBarColumnNo: 6
  },
  {
    title: 'CRM Call',
    route: '/crm-call',
    component: CrmCalling,
    zoomuinewroute: true
  },
  {
    title: 'Client Communication',
    route: '/cms',
    component: CmsPage,
    roles: ['ROLE_SEND_CLIENT_COMMUNICATION'],
    zoomuinewroute: true,
    menuBarColumnNo: 3
  },
  {
    title: 'Consolidated EWB Creator',
    route: '/consolidated-ewb-creator',
    zoomuinewroute: true,
    roles: ['ROLE_CEWB_VEHICLE_MAPPING_EDIT'],
    menuBarColumnNo: 3,
    component: ConsolidatedEwCreator
  },
  {
    title: 'Claims Management',
    route: '/claims',
    exact: true,
    zoomuinewroute: true,
    roles: [
      'ROLE_CLAIM_GROUND_DEPS',
      'ROLE_CLAIM_CLM',
      'ROLE_CLAIM_HOD_DESK',
      'ROLE_CLAIM_OPS_HOD',
      'ROLE_CLAIM_SALES_HOD',
      'ROLE_CLAIM_FINANCE',
      'ROLE_CLAIM_CLIENT_USER',
      'ROLE_CLAIM_RP_USER',
      'ROLE_CLAIM_SAM_KAM',
      'ROLE_CLAIM_DESK',
      'ROLE_CLAIM_HQ_DEPS'
    ],
    menuBarColumnNo: 3,
    component: ClaimsDashboard
  },
  {
    title: 'EPOD',
    route: '/epod',
    component: EPod,
    zoomuinewroute: true
  },
  {
    title: 'NotFound',
    route: '/login',
    roles: ['ROLE_ANONYMOUS_USER'],
    component: LoginOtp,
    zoomuinewroute: true
  },
  {
    title: 'NotFound',
    route: '/pagenotfound',
    zoomuinewroute: true,
    roles: [],
    component: NotFoundPage,
    exact: true
  },
  {
    title: 'NotFound',
    route: '/',
    zoomuinewroute: true,
    roles: [],
    component: NotFoundPage,
    exact: false
  }
];

export default routesConfig;
